.logo {
  height: 2.3rem;
  width: auto;
  object-fit: contain;
}

.loginLogoContainer {
  padding: 1.1rem 1.75rem;
}

.loginLogo {
  height: 2.6rem;
  object-fit: contain;
}

.welcome {
  position: absolute;
  top: 10vh;
  height: fit-content;
}

.layout {
  display: grid;
  height: 100vh;
  overflow: hidden;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.1fr 0.2fr 3fr;
  grid-template-areas:
    'sidebar sidebar sidebar sidebar sidebar sidebar'
    'main main main main main main'
    'main main main main main main';
}

.layoutPromotion {
  display: grid;
  height: 100vh;
  overflow: hidden;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.1fr 0.2fr 3fr;
  grid-template-areas:
    'promo promo promo promo promo promo'
    'sidebar sidebar sidebar sidebar sidebar sidebar'
    /* 'nav nav nav nav nav nav' */
    'main main main main main main';
}

.sidebarBig {
  display: flex;
  height: 4.4rem;
  /* left: 0; */
  /* right: 0; */
  padding: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  border-bottom: 1px solid var(--ib-navy-line);
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  grid-area: sidebar;
  background-color: var(--sidebar-bg-color);
}

/* Center the header content on the same 1240px column as the page body */
.headerInner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  /* match the pages' 24px horizontal padding so the logo/wallet align with the body columns */
  padding: 0 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

/* Right cluster of the navy header: nav links + wallet control */
.headerRight {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1.6rem;
}

.headerWallet {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  padding-left: 1.1rem;
  border-left: 1px solid var(--ib-navy-line);
}

.walletBalanceBlock {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  line-height: 1.15;
}

.walletBalanceLabel {
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #a9b6c6;
}

.walletBalanceValue {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #ffffff;
  font-variant-numeric: tabular-nums lining-nums;
}

.addFundsBtn {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  border: 0;
  cursor: pointer;
  background: var(--ib-red);
  color: #ffffff;
  font-weight: 700;
  font-size: 0.9rem;
  padding: 0.6rem 1rem;
  border-radius: 9px;
  transition: background 0.15s ease;
}

.addFundsBtn:hover {
  background: var(--ib-red-d);
}

.addFundsPlus {
  font-size: 1.15rem;
  line-height: 1;
  margin-top: -1px;
}

.sidebarSmall {
  display: none;
  background-color: var(--sidebar-bg-color);
}

.loginTopBar {
  background-color: var(--sidebar-bg-color);
}

.nav {
  /* Subtracting sidebarBig's height */
  height: calc(100vh - 4.4rem);
  grid-area: nav;
}

.promoNavBar {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.6rem 1.5rem;
  background-color: var(--promo-bg-color);
  grid-area: promo;
}

.promoNavBar:hover {
  cursor: pointer;
}

.main {
  /* Required to make sidebar stick */
  overflow: auto;
  grid-area: main;
  background-color: var(--main-bg-color);
}

.content {
  min-height: 85vh;
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
}

.additionalNavLinks {
  /* border-top: 0.8px solid hsl(0, 0%, 60%); */
  display: flex;
  flex-direction: row;
  gap: 0.3rem;
  /* padding-top: 0.3rem; */
}

.additionalNavLinkBtn {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectedNav {
  color: var(--navbar-selected-button-text-color) !important;
}

ion-icon {
  font-size: 1.25rem;
  color: #b3c0d0;
  padding-right: 0.5rem;
}

ion-icon:hover {
  color: var(--navbar-selected-button-text-color);
}

@media only screen and (max-width: 550px) {
  /* Mobile: abandon the 100vh/overflow:hidden grid (it trapped #main's scroll behind the
     browser chrome so the footer was never reachable). Use natural document scroll with a
     FIXED bottom nav; pad the content so the footer clears the fixed bar. */
  .layout,
  .layoutPromotion {
    display: block;
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }

  .main {
    overflow: visible;
    height: auto;
    padding-bottom: calc(9vh + env(safe-area-inset-bottom));
  }

  .sidebarBig {
    display: none;
  }

  .sidebarSmall {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    height: calc(9vh + env(safe-area-inset-bottom));
    padding-bottom: env(safe-area-inset-bottom);
  }
}
